import { render } from "./CookieComponents.vue?vue&type=template&id=65aea798"
import script from "./CookieComponents.vue?vue&type=script&lang=js"
export * from "./CookieComponents.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__